import { useQuery } from "@tanstack/react-query";
import { fetchSavedList } from "common/apis/savedplaces";
import { Storage } from "common/storage";

export function useGetSavedList(listId: string, profileId?: string) {
  const accessToken = Storage.getCurrentUserToken();
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["getSavedList", listId],
    queryFn: () => {
      return fetchSavedList(listId, profileId, accessToken);
    },
  });
  return {
    savedList: data,
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
}
